import { composeWithDevTools } from "@redux-devtools/extension";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import StepperReducer from "./reducers/StepperReducer";
import FirstInfoReducer from "./reducers/FirstInfoReducer";
import TokenReducer from "./reducers/TokenReducer";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'
import CompleteInfoReducer from "./reducers/CompleteInfoReducer";
import TokenGenerateKeyReducer from "./reducers/TokenGenerateKeyReducer";
import AdminPortalReducer from "./reducers/AdminPortalReducer";
import LeaderPortalReducer from "./reducers/LeaderPortalReducer";

const reducers = combineReducers({
    Stepper: StepperReducer,
    FirstInfo: FirstInfoReducer,
    Token: TokenReducer,
    CompleteInfo: CompleteInfoReducer,
    TokenGenerateKeyResponse : TokenGenerateKeyReducer,
    AdminPortal: AdminPortalReducer,
    LeaderPortal: LeaderPortalReducer,

})

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, reducers)
window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// export default () => {
    export let store = createStore(persistedReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
    export let persistor = persistStore(store)
//     return { store, persistor }
// }

// const initialState = {
// };

// const middleware = [thunk];

// const store = createStore(
//     reducers,
//     initialState,
//     composeWithDevTools(applyMiddleware(...middleware))
// )

// export default store